export const uniqueArray = <T>(array: T[]): T[] => [...new Set(array)];
